export default "__VITE_ASSET__BYot44Ch__"